<div class="dsg-published">
  @if (error()) {
    <div class="dsg-published-state">{{ error() }}</div>
  } @else {
    @if (screens().length > 1) {
      <nav class="dsg-published-tabs" aria-label="Screens">
        @for (screen of screens(); track screen.id) {
          <button
            type="button"
            class="dsg-published-tab"
            [class.is-active]="screen.id === activeScreen()?.id"
            (click)="selectScreen(screen.id)"
          >{{ screen.name }}</button>
        }
      </nav>
    }

    @if (activeScreen(); as screen) {
      <app-design-screen-preview class="dsg-published-screen" [screen]="screen" mode="fit-width"></app-design-screen-preview>
    } @else {
      <div class="dsg-published-state">This dashboard has no screens.</div>
    }
  }

  <!-- A button's Open popup → screen. -->
  <app-design-screen-popup></app-design-screen-popup>

  <!-- Never shown: its family steps apply recompute results to the widgets. -->
  <app-design-build-host class="dsg-published-engine" [engineOnly]="true" [node]="null" aria-hidden="true"></app-design-build-host>
</div>
